/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_Tomorrow_OutcomeInputs */

const en_inbound_waiting_on_tomorrow_outcome = /** @type {(inputs: Inbound_Waiting_On_Tomorrow_OutcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Tomorrow · confirm what was received · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Tomorrow · confirm what was received · since {since}" |
*
* @param {Inbound_Waiting_On_Tomorrow_OutcomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_tomorrow_outcome = /** @type {((inputs: Inbound_Waiting_On_Tomorrow_OutcomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_Tomorrow_OutcomeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_tomorrow_outcome(inputs)
});